import { render, staticRenderFns } from "./CustomerAddressList.vue?vue&type=template&id=cf82ed92&scoped=true&"
import script from "./CustomerAddressList.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddressList.vue?vue&type=style&index=0&id=cf82ed92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82ed92",
  null
  
)

export default component.exports